export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/c65739bb-e7ed-4cf3-980a-48737a86f622.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/f21ad08a-ef71-4f45-9897-ece479d64d0d.png',
};
